import React from "react";
import COMPANY from "../../data/company.js";

/* ============================================================================
   BRAND LOCKUP

   The horizontal version of the logo: truck and wordmark, no tagline. Cut from
   the full artwork in frontend/public/, with the white background keyed out to
   transparency so it sits on the translucent header without a white box behind
   it.

   Two variants, because a navy logo is invisible on a navy footer:
     "dark"  — the brand blue, for white and light backgrounds (header)
     "light" — reversed to white, for navy backgrounds (footer)

   The tagline is deliberately not part of this. At header size it would be
   illegible, and the site already carries that line in the footer copy.
   ========================================================================== */

const SRC = {
  dark: "/logo-lockup-dark.png",
  light: "/logo-lockup-light.png",
};

const LogoLockup = ({ variant = "dark", className = "" }) => (
  <img
    className={`brand-lockup ${className}`.trim()}
    src={SRC[variant] || SRC.dark}
    alt={`${COMPANY.name} — ${COMPANY.tagline}`}
    width="472"
    height="160"
    draggable="false"
  />
);

export default LogoLockup;
